import React from 'react'
import PropTypes from 'prop-types'
import {GridItem, SimpleGrid} from '@chakra-ui/react'
import {Component} from '@salesforce/commerce-sdk-react/components'

/**
 * PDCEditoBigTilesDuo is a React functional component that renders a grid layout
 * of components using the SimpleGrid component. It is designed to display a list
 * of components in a two-column format, with specific spacing and padding.
 *
 * @param {Object} props - The properties object.
 * @param {Array} props.productList - An array of products to be associated with each component.
 * @param {Object} props.category - The category object to be associated with each component.
 * @param {Array} props.regions - An array of region objects, where each region contains a list of components.
 *
 * @returns {JSX.Element} A JSX element representing a grid of components.
 *
 * The component extracts the list of components from the first region in the regions array,
 * if available. Each component is then enhanced with additional properties such as productList,
 * category, and imageSizes before being rendered within a GridItem. The grid layout is responsive
 * and adjusts its padding and spacing based on the screen size.
 */
export const PDCEditoBigTilesDuo = ({productList, category, layoutIndex, regions}) => {
    let components = []
    if (regions) {
        components = regions[0].components || []
    }

    return (
        <SimpleGrid
            as="ul"
            listStyleType="none"
            columns={[2]}
            spacingX={10}
            px={[0, 0, 0, '14.3%']}
            py={[0, 0, 0, 70]}
        >
            {components.map((component, index) => {
                component.productList = productList
                component.category = category
                component.imageSizes = ['50vw', '50vw', '50vw', '35vw', '35vw', '35vw']
                component.layoutIndex = layoutIndex
                return (
                    <GridItem as="li" key={component?.id || index}>
                        <Component component={component} />
                    </GridItem>
                )
            })}
        </SimpleGrid>
    )
}

PDCEditoBigTilesDuo.propTypes = {
    productList: PropTypes.array,
    category: PropTypes.object,
    layoutIndex: PropTypes.number,
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.object,
                    id: PropTypes.string,
                    typeId: PropTypes.string
                })
            )
        })
    )
}
